export const css = {
	root: '_3Q7KK3iF',
	wrapper: '_35xpaSlY',
	field: '_2XTQmmtn',
	bar: 'KewMxidO',
	' _key': 'prepost-viz/completed-viz'
};

export default css;
